import React, { useRef, useEffect, useCallback, useState, useMemo, useContext } from 'react';
import axios from 'axios';
export { default as axios } from 'axios';
import debounce from 'lodash.debounce';
import throttle from 'lodash.throttle';

var fetcher = {};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var dynamicLocaleDirPath = 'dynamicLocale'; // 远程资源目录名

var restConfig = {
    endpoint: typeof window !== 'undefined' ? window.location.protocol + '//' + window.location.host : ''
};
function config(options) {
    restConfig = __assign({}, restConfig, options);
}

function fetch(url, options) {
    return __awaiter(this, void 0, void 0, function () {
        var configInterceptors, endpoint, rest, interceptor, instance, _a, handleRequest, handleRequestError, _b, handleResponse, handleResponseError, reqURL, isAbsoluteURL, arr, response, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    configInterceptors = restConfig.interceptor, endpoint = restConfig.endpoint, rest = __rest(restConfig, ["interceptor", "endpoint"]);
                    interceptor = {};
                    if (configInterceptors)
                        interceptor = configInterceptors;
                    instance = axios.create(__assign({}, rest));
                    // 需要支持多个拦截器的情况
                    // 一个拦截器的情况：
                    // interceptor: {
                    //   responses: [handleResponse, handleResponseError], 第一个参数表示成功的处理函数，第二个参数表示失败的处理函数
                    // }
                    // 多个拦截器的情况：
                    // interceptor: {
                    //  responses: [
                    //    [handleResponse1, handleResponseError1],
                    //    [handleResponse2, handleResponseError2],
                    // ], 第一个参数表示成功的处理函数，第二个参数表示失败的处理函数
                    // }
                    // 请求拦截器 需要支持多个拦截器的情况
                    if (interceptor.requests && Array.isArray(interceptor.requests)) {
                        interceptor.requests.forEach(function (item) {
                            if (Array.isArray(item)) {
                                var req = item[0], reqErr = item[1];
                                if (typeof reqErr === 'function') {
                                    instance.interceptors.request.use(req, reqErr);
                                }
                                else {
                                    instance.interceptors.request.use(req);
                                }
                            }
                        });
                        _a = interceptor.requests, handleRequest = _a[0], handleRequestError = _a[1];
                        if (typeof handleRequest === 'function' && typeof handleRequestError === 'function') {
                            instance.interceptors.request.use(handleRequest, handleRequestError);
                        }
                        else if (typeof handleRequest === 'function' && handleRequestError === undefined) {
                            instance.interceptors.request.use(handleRequest);
                        }
                    }
                    // 响应拦截器 需要支持多个拦截器的情况
                    if (interceptor.responses && Array.isArray(interceptor.responses)) {
                        interceptor.responses.forEach(function (item) {
                            if (Array.isArray(item)) {
                                var res = item[0], resErr = item[1];
                                if (typeof resErr === 'function') {
                                    instance.interceptors.response.use(res, resErr);
                                }
                                else {
                                    instance.interceptors.response.use(res);
                                }
                            }
                        });
                        _b = interceptor.responses, handleResponse = _b[0], handleResponseError = _b[1];
                        if (typeof handleResponse === 'function' && typeof handleResponseError === 'function') {
                            instance.interceptors.response.use(handleResponse, handleResponseError);
                        }
                        else if (typeof handleResponse === 'function' && handleResponseError === undefined) {
                            instance.interceptors.response.use(handleResponse);
                        }
                    }
                    reqURL = url;
                    isAbsoluteURL = /http:\/\/|https:\/\//.test(url);
                    if (url.indexOf(dynamicLocaleDirPath) > -1) {
                        reqURL = url;
                    }
                    else if (isAbsoluteURL) {
                        reqURL = url;
                    }
                    else {
                        arr = url.split(/\s+/);
                        // handle something like: 'POST: /todos'
                        if (arr.length === 2) {
                            reqURL = arr[0] + " " + (endpoint + arr[1]);
                        }
                        else {
                            reqURL = endpoint + arr[0];
                        }
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, instance(__assign({}, options, { url: reqURL }))];
                case 2:
                    response = _c.sent();
                    if (response) {
                        if (options && options.returnOriginalRes) {
                            return [2 /*return*/, Promise.resolve(response)];
                        }
                        else {
                            return [2 /*return*/, Promise.resolve(response.data)];
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    throw error_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}

function isDocumentVisible() {
    if (typeof document !== 'undefined' && typeof document.visibilityState !== 'undefined') {
        return document.visibilityState !== 'hidden';
    }
    return true;
}
function isOnline() {
    if (typeof navigator.onLine !== 'undefined') {
        return navigator.onLine;
    }
    return true;
}

var cache = {};
var setCache = function (key, data) {
    if (cache[key]) {
        clearTimeout(cache[key].timer);
    }
    // 数据在不活跃 5min 后，删除掉
    var timer = setTimeout(function () {
        delete cache[key];
    }, 5 * 60 * 1000);
    cache[key] = {
        data: data,
        timer: timer
    };
};
var getCache = function (key) { return cache[key] ? cache[key].data : undefined; };

function limit(fn, timespan) {
    var pending = false;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (pending)
            return;
        pending = true;
        fn.apply(void 0, args);
        setTimeout(function () { pending = false; }, timespan);
    };
}

function usePersistFn(fn, dependencies) {
    if (dependencies === void 0) { dependencies = []; }
    var ref = useRef(function () {
        throw new Error('Cannot call an event handler while rendering.');
    });
    useEffect(function () {
        ref.current = fn;
    }, [fn].concat(dependencies));
    var persist = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var refFn = ref.current;
        if (refFn) {
            return refFn.apply(void 0, args);
        }
    }, [ref]);
    if (typeof fn === 'function') {
        return persist;
    }
    return undefined;
}

var useUpdateEffect = function (effect, deps) {
    var isMounted = useRef(false);
    useEffect(function () {
        if (!isMounted.current) {
            isMounted.current = true;
        }
        else {
            return effect();
        }
    }, deps);
};

// from swr
var listeners = [];
function subscribe(listener) {
    listeners.push(listener);
    return function unsubscribe() {
        var index = listeners.indexOf(listener);
        listeners.splice(index, 1);
    };
}
var eventsBinded = false;
if (typeof window !== 'undefined' && window.addEventListener && !eventsBinded) {
    var revalidate = function () {
        if (!isDocumentVisible() || !isOnline())
            return;
        for (var i = 0; i < listeners.length; i++) {
            var listener = listeners[i];
            listener();
        }
    };
    window.addEventListener('visibilitychange', revalidate, false);
    window.addEventListener('focus', revalidate, false);
    // only bind the events once
    eventsBinded = true;
}

// from swr
var listeners$1 = [];
function subscribe$1(listener) {
    listeners$1.push(listener);
    return function unsubscribe() {
        var index = listeners$1.indexOf(listener);
        listeners$1.splice(index, 1);
    };
}
var eventsBinded$1 = false;
if (typeof window !== 'undefined' && window.addEventListener && !eventsBinded$1) {
    var revalidate$1 = function () {
        if (!isDocumentVisible())
            return;
        for (var i = 0; i < listeners$1.length; i++) {
            var listener = listeners$1[i];
            listener();
        }
    };
    window.addEventListener('visibilitychange', revalidate$1, false);
    // only bind the events once
    eventsBinded$1 = true;
}

var DEFAULT_KEY = 'UMIJS_USE_API_DEFAULT_KEY';
var Fetch = /** @class */ (function () {
    function Fetch(service, config, subscribe$2, initState) {
        // 请求时序
        this.count = 0;
        // 是否卸载
        this.unmountedFlag = false;
        // visible 后，是否继续轮询
        this.pollingWhenVisibleFlag = false;
        this.pollingTimer = undefined;
        this.loadingDelayTimer = undefined;
        this.unsubscribe = [];
        this.that = this;
        this.state = {
            loading: false,
            params: [],
            data: undefined,
            error: undefined,
            run: this.run.bind(this.that),
            mutate: this.mutate.bind(this.that),
            refresh: this.refresh.bind(this.that),
            cancel: this.cancel.bind(this.that),
            unmount: this.unmount.bind(this.that)
        };
        this.service = service;
        this.config = config;
        this.subscribe = subscribe$2;
        if (initState) {
            this.state = __assign({}, this.state, initState);
        }
        this.debounceRun = this.config.debounceInterval ? debounce(this._run, this.config.debounceInterval) : undefined;
        this.throttleRun = this.config.throttleInterval ? throttle(this._run, this.config.throttleInterval) : undefined;
        this.limitRefresh = limit(this.refresh.bind(this), this.config.focusTimespan);
        if (this.config.pollingInterval) {
            this.unsubscribe.push(subscribe$1(this.rePolling.bind(this)));
        }
        if (this.config.refreshOnWindowFocus) {
            this.unsubscribe.push(subscribe(this.limitRefresh.bind(this)));
        }
    }
    Fetch.prototype.setState = function (s) {
        if (s === void 0) { s = {}; }
        this.state = __assign({}, this.state, s);
        this.subscribe(this.state);
    };
    Fetch.prototype._run = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // 取消已有定时器
        if (this.pollingTimer) {
            clearTimeout(this.pollingTimer);
        }
        // 取消 loadingDelayTimer
        if (this.loadingDelayTimer) {
            clearTimeout(this.loadingDelayTimer);
        }
        this.count += 1;
        // 闭包存储当次请求的 count
        var currentCount = this.count;
        this.setState({
            loading: !this.config.loadingDelay,
            params: args
        });
        if (this.config.loadingDelay) {
            this.loadingDelayTimer = setTimeout(function () {
                _this.setState({
                    loading: true
                });
            }, this.config.loadingDelay);
        }
        return this.service.apply(this, args).then(function (res) {
            if (!_this.unmountedFlag && currentCount === _this.count) {
                if (_this.loadingDelayTimer) {
                    clearTimeout(_this.loadingDelayTimer);
                }
                var formattedResult = _this.config.formatResult ? _this.config.formatResult(res) : res;
                _this.setState({
                    data: formattedResult,
                    error: undefined,
                    loading: false
                });
                if (_this.config.onSuccess) {
                    _this.config.onSuccess(formattedResult, args);
                }
                return formattedResult;
            }
        }).catch(function (error) {
            if (!_this.unmountedFlag && currentCount === _this.count) {
                if (_this.loadingDelayTimer) {
                    clearTimeout(_this.loadingDelayTimer);
                }
                _this.setState({
                    data: undefined,
                    error: error,
                    loading: false
                });
                if (_this.config.onError) {
                    _this.config.onError(error, args);
                }
                // eslint-disable-next-line
                console.error(error);
                return error;
                // throw error;
            }
        }).finally(function () {
            if (!_this.unmountedFlag && currentCount === _this.count) {
                if (_this.config.pollingInterval) {
                    // 如果屏幕隐藏，并且 !pollingWhenHidden, 则停止轮询，并记录 flag，等 visible 时，继续轮询
                    if (!isDocumentVisible() && !_this.config.pollingWhenHidden) {
                        _this.pollingWhenVisibleFlag = true;
                        return;
                    }
                    _this.pollingTimer = setTimeout(function () {
                        _this._run.apply(_this, args);
                    }, _this.config.pollingInterval);
                }
            }
        });
    };
    Fetch.prototype.run = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this.debounceRun) {
            this.debounceRun.apply(this, args);
            // TODO 如果 options 存在 debounceInterval，或 throttleInterval，则 run 和 refresh 不会返回 Promise。 带类型需要修复后，此处变成 return;。
            return Promise.resolve(null);
        }
        if (this.throttleRun) {
            this.throttleRun.apply(this, args);
            return Promise.resolve(null);
        }
        return this._run.apply(this, args);
    };
    Fetch.prototype.cancel = function () {
        if (this.debounceRun) {
            this.debounceRun.cancel();
        }
        if (this.throttleRun) {
            this.throttleRun.cancel();
        }
        if (this.loadingDelayTimer) {
            clearTimeout(this.loadingDelayTimer);
        }
        if (this.pollingTimer) {
            clearTimeout(this.pollingTimer);
        }
        this.pollingWhenVisibleFlag = false;
        this.count += 1;
        this.setState({
            loading: false
        });
    };
    Fetch.prototype.refresh = function () {
        return this.run.apply(this, this.state.params);
    };
    Fetch.prototype.rePolling = function () {
        if (this.pollingWhenVisibleFlag) {
            this.pollingWhenVisibleFlag = false;
            this.refresh();
        }
    };
    Fetch.prototype.mutate = function (data) {
        if (typeof data === 'function') {
            this.setState({
                // eslint-disable-next-line
                data: data(this.state.data) || {}
            });
        }
        else {
            this.setState({
                data: data
            });
        }
    };
    Fetch.prototype.unmount = function () {
        this.unmountedFlag = true;
        this.cancel();
        this.unsubscribe.forEach(function (s) {
            s();
        });
    };
    return Fetch;
}());
function useAsync(service, options) {
    var _options = options || {};
    var _a = _options.refreshDeps, refreshDeps = _a === void 0 ? [] : _a, _b = _options.manual, manual = _b === void 0 ? false : _b, _c = _options.onSuccess, onSuccess = _c === void 0 ? function () { } : _c, _d = _options.onError, onError = _d === void 0 ? function () { } : _d, _e = _options.defaultLoading, defaultLoading = _e === void 0 ? false : _e, loadingDelay = _options.loadingDelay, _f = _options.pollingInterval, pollingInterval = _f === void 0 ? 0 : _f, _g = _options.pollingWhenHidden, pollingWhenHidden = _g === void 0 ? true : _g, _h = _options.defaultParams, defaultParams = _h === void 0 ? [] : _h, _j = _options.refreshOnWindowFocus, refreshOnWindowFocus = _j === void 0 ? false : _j, _k = _options.focusTimespan, focusTimespan = _k === void 0 ? 5000 : _k, fetchKey = _options.fetchKey, cacheKey = _options.cacheKey, debounceInterval = _options.debounceInterval, throttleInterval = _options.throttleInterval, initialData = _options.initialData;
    var newstFetchKey = useRef(DEFAULT_KEY);
    // 持久化一些函数
    var servicePersist = usePersistFn(service);
    var onSuccessPersist = usePersistFn(onSuccess);
    var onErrorPersist = usePersistFn(onError);
    var fetchKeyPersist = usePersistFn(fetchKey);
    var formatResult;
    if ('formatResult' in _options) {
        // eslint-disable-next-line prefer-destructuring
        formatResult = _options.formatResult;
    }
    var formatResultPersist = usePersistFn(formatResult);
    var config = {
        formatResult: formatResultPersist,
        onSuccess: onSuccessPersist,
        onError: onErrorPersist,
        loadingDelay: loadingDelay,
        pollingInterval: pollingInterval,
        pollingWhenHidden: pollingWhenHidden,
        refreshOnWindowFocus: refreshOnWindowFocus,
        focusTimespan: focusTimespan,
        debounceInterval: debounceInterval,
        throttleInterval: throttleInterval
    };
    var subscribe = usePersistFn(function (key, data) {
        setFeches(function (s) {
            // eslint-disable-next-line no-param-reassign
            s[key] = data;
            return __assign({}, s);
        });
    }, []);
    var _l = useState(function () {
        // 如果有 缓存，则从缓存中读数据
        if (cacheKey) {
            var cache_1 = getCache(cacheKey);
            if (cache_1) {
                newstFetchKey.current = cache_1.newstFetchKey;
                /* 使用 initState, 重新 new Fetch */
                var newFetches_1 = {};
                Object.keys(cache_1.fetches).forEach(function (key) {
                    var cacheFetch = cache_1.fetches[key];
                    var newFetch = new Fetch(servicePersist, config, subscribe.bind(null, key), {
                        loading: cacheFetch.loading,
                        params: cacheFetch.params,
                        data: cacheFetch.data,
                        error: cacheFetch.error
                    });
                    newFetches_1[key] = newFetch.state;
                });
                return newFetches_1;
            }
        }
        return [];
    }), fetches = _l[0], setFeches = _l[1];
    var fetchesRef = useRef(fetches);
    fetchesRef.current = fetches;
    var run = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (fetchKeyPersist) {
            var key = fetchKeyPersist.apply(void 0, args);
            newstFetchKey.current = key === undefined ? DEFAULT_KEY : key;
        }
        var currentFetchKey = newstFetchKey.current;
        // 这里必须用 fetchsRef，而不能用 fetches。
        // 否则在 reset 完，立即 run 的时候，这里拿到的 fetches 是旧的。
        var currentFetch = fetchesRef.current[currentFetchKey];
        if (!currentFetch) {
            var newFetch = new Fetch(servicePersist, config, subscribe.bind(null, currentFetchKey), {
                data: initialData
            });
            currentFetch = newFetch.state;
            setFeches(function (s) {
                // eslint-disable-next-line no-param-reassign
                s[currentFetchKey] = currentFetch;
                return __assign({}, s);
            });
        }
        return currentFetch.run.apply(currentFetch, args);
    }, [fetchKey, subscribe]);
    // cache
    useEffect(function () {
        if (cacheKey) {
            setCache(cacheKey, {
                fetches: fetches,
                newstFetchKey: newstFetchKey.current
            });
        }
    }, [cacheKey, fetches]);
    // 第一次默认执行
    useEffect(function () {
        if (!manual) {
            // 如果有缓存
            if (Object.keys(fetches).length > 0) {
                /* 重新执行所有的 */
                Object.values(fetches).forEach(function (f) {
                    f.refresh();
                });
            }
            else {
                // 第一次默认执行，可以通过 defaultParams 设置参数
                run.apply(void 0, defaultParams);
            }
        }
    }, []);
    // 重置 fetches
    var reset = useCallback(function () {
        Object.values(fetchesRef.current).forEach(function (f) {
            f.unmount();
        });
        newstFetchKey.current = DEFAULT_KEY;
        setFeches({});
        // 不写会有问题。如果不写，此时立即 run，会是老的数据
        fetchesRef.current = {};
    }, [setFeches]);
    //  refreshDeps 变化，重新执行所有请求
    useUpdateEffect(function () {
        if (!manual) {
            /* 全部重新执行 */
            Object.values(fetchesRef.current).forEach(function (f) {
                f.refresh();
            });
        }
    }, refreshDeps.slice());
    // 卸载组件触发
    useEffect(function () { return function () {
        Object.values(fetchesRef.current).forEach(function (f) {
            f.unmount();
        });
    }; }, []);
    var noReady = useCallback(function (name) { return function () {
        throw new Error("Cannot call " + name + " when service not executed once.");
    }; }, []);
    return __assign({ loading: !manual || defaultLoading, data: initialData, error: undefined, params: [], cancel: noReady('cancel'), refresh: noReady('refresh'), mutate: noReady('mutate') }, (fetches[newstFetchKey.current] || {}), { run: run,
        fetches: fetches,
        reset: reset });
}

function useLoadMore(service, options) {
    var _a = options.refreshDeps, refreshDeps = _a === void 0 ? [] : _a, ref = options.ref, isNoMore = options.isNoMore, _b = options.threshold, threshold = _b === void 0 ? 100 : _b, fetchKey = options.fetchKey, restOptions = __rest(options, ["refreshDeps", "ref", "isNoMore", "threshold", "fetchKey"]);
    var _c = useState(false), loadingMore = _c[0], setLoadingMore = _c[1];
    useEffect(function () {
        if (options.fetchKey) {
            console.warn('useRequest loadMore mode don\'t need fetchKey!');
        }
    }, []);
    var result = useAsync(service, __assign({}, restOptions, { fetchKey: function (d) { return ((d && d.list && d.list.length) ? d.list.length : 0); }, onSuccess: function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            setLoadingMore(false);
            if (options.onSuccess) {
                options.onSuccess.apply(options, params);
            }
        } }));
    var data = result.data, run = result.run, params = result.params, reset = result.reset, loading = result.loading, fetches = result.fetches;
    var reload = useCallback(function () {
        reset();
        var restParams = params.slice(1);
        run.apply(void 0, [undefined].concat(restParams));
    }, [run, reset, params]);
    var reloadRef = useRef(reload);
    reloadRef.current = reload;
    /* loadMore 场景下，如果 refreshDeps 变化，重置到第一页 */
    useUpdateEffect(function () {
        /* 只有自动执行的场景， refreshDeps 才有效 */
        if (!options.manual) {
            reloadRef.current();
        }
    }, refreshDeps.slice());
    var dataGroup = useMemo(function () {
        var listGroup = [];
        // 在 loadMore 时，不希望清空上一次的 data。需要把最后一个 非 loading 的请求 data，放回去。
        var lastNoLoadingData = data;
        Object.values(fetches).forEach(function (h) {
            if (h.data && h.data.list) {
                listGroup = listGroup.concat(h.data ? h.data.list : []);
            }
            if (!h.loading) {
                lastNoLoadingData = h.data;
            }
        });
        return __assign({}, lastNoLoadingData, { list: listGroup });
    }, [fetches, data]);
    var noMore = isNoMore ? (!loading && !loadingMore && isNoMore(dataGroup)) : false;
    var loadMore = useCallback(function () {
        if (noMore) {
            return;
        }
        setLoadingMore(true);
        var restParams = params.slice(1);
        run.apply(void 0, [dataGroup].concat(restParams));
    }, [noMore, run, dataGroup, params]);
    /* 上拉加载的方法 */
    var scrollMethod = useCallback(function () {
        if (loading || !ref || !ref.current) {
            return;
        }
        if (ref.current.scrollHeight - ref.current.scrollTop <= ref.current.clientHeight + threshold) {
            loadMore();
        }
    }, [loading, ref, loadMore]);
    /* 如果有 ref，则会上拉加载更多 */
    useEffect(function () {
        if (!ref || !ref.current) {
            return function () { };
        }
        ref.current.addEventListener('scroll', scrollMethod);
        return function () {
            if (ref && ref.current) {
                ref.current.removeEventListener('scroll', scrollMethod);
            }
        };
    }, [scrollMethod]);
    return __assign({}, result, { data: dataGroup, reload: reload, loading: loading && dataGroup.list.length === 0, loadMore: loadMore,
        loadingMore: loadingMore,
        noMore: noMore });
}

function usePaginated(service, options) {
    var paginated = options.paginated, _a = options.defaultPageSize, defaultPageSize = _a === void 0 ? 10 : _a, _b = options.refreshDeps, refreshDeps = _b === void 0 ? [] : _b, fetchKey = options.fetchKey, restOptions = __rest(options, ["paginated", "defaultPageSize", "refreshDeps", "fetchKey"]);
    useEffect(function () {
        if (fetchKey) {
            // eslint-disable-next-line
            console.error('useRequest pagination\'s fetchKey will not work!');
        }
    }, []);
    var _c = useAsync(service, __assign({}, restOptions, { defaultParams: [{
                current: 1,
                pageSize: defaultPageSize
            }] })), data = _c.data, params = _c.params, run = _c.run, loading = _c.loading, rest = __rest(_c, ["data", "params", "run", "loading"]);
    var _d = params && params[0] ? params[0] : {}, _e = _d.current, current = _e === void 0 ? 1 : _e, _f = _d.pageSize, pageSize = _f === void 0 ? defaultPageSize : _f, _g = _d.sorter, sorter = _g === void 0 ? {} : _g, _h = _d.filters, filters = _h === void 0 ? {} : _h;
    // 只改变 pagination，其他参数原样传递
    var runChangePaination = useCallback(function (paginationParams) {
        var oldPaginationParams = params[0], restParams = params.slice(1);
        run.apply(void 0, [__assign({}, oldPaginationParams, paginationParams)].concat(restParams));
    }, [run, params]);
    var total = data ? data.total : 0;
    var totalPage = useMemo(function () { return Math.ceil(total / pageSize); }, [pageSize, total]);
    var onChange = useCallback(function (c, p) {
        runChangePaination({
            current: c,
            pageSize: p
        });
    }, [total, runChangePaination]);
    var changeCurrent = useCallback(function (c) {
        onChange(c, pageSize);
    }, [onChange, pageSize]);
    var changePageSize = useCallback(function (p) {
        onChange(current, p);
    }, [onChange, current]);
    var changeCurrentRef = useRef(changeCurrent);
    changeCurrentRef.current = changeCurrent;
    /* 分页场景下，如果 refreshDeps 变化，重置分页 */
    useUpdateEffect(function () {
        /* 只有自动执行的场景， refreshDeps 才有效 */
        if (!options.manual) {
            changeCurrentRef.current(1);
        }
    }, refreshDeps.slice());
    // 表格翻页 排序 筛选等
    var changeTable = useCallback(function (p, f, s) {
        runChangePaination({
            current: p.current,
            pageSize: p.pageSize || defaultPageSize,
            filters: f,
            sorter: s
        });
    }, [filters, sorter, runChangePaination]);
    return __assign({ loading: loading,
        data: data,
        params: params,
        run: run, pagination: {
            current: current,
            pageSize: pageSize,
            total: total,
            totalPage: totalPage,
            onChange: onChange,
            changeCurrent: changeCurrent,
            changePageSize: changePageSize
        }, tableProps: {
            dataSource: data ? data.list : [],
            loading: loading,
            onChange: changeTable,
            pagination: {
                current: current,
                pageSize: pageSize,
                total: total
            }
        }, sorter: sorter,
        filters: filters }, rest);
}

var ConfigContext = React.createContext({});
ConfigContext.displayName = 'UseAPIConfigContext';

function useRequest(service, options) {
    if (options === void 0) { options = {}; }
    var contextConfig = useContext(ConfigContext);
    var finalOptions = __assign({}, contextConfig, options);
    var paginated = finalOptions.paginated, loadMore = finalOptions.loadMore, requestMethod = finalOptions.requestMethod;
    var paginatedRef = useRef(paginated);
    var loadMoreRef = useRef(loadMore);
    if (paginatedRef.current !== paginated) {
        throw Error('You should not modify the paginated of options');
    }
    if (loadMoreRef.current !== loadMore) {
        throw Error('You should not modify the loadMore of options');
    }
    paginatedRef.current = paginated;
    loadMoreRef.current = loadMore;
    var finalRequestMethod = requestMethod || fetch;
    var promiseService;
    if (typeof service === 'string') {
        promiseService = function () { return finalRequestMethod(service); };
    }
    else if (typeof service === 'object') {
        var url_1 = service.url, rest_1 = __rest(service, ["url"]);
        promiseService = function () { return finalRequestMethod(url_1, rest_1); };
    }
    else {
        promiseService = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new Promise(function (resolve, reject) {
                var result = service.apply(void 0, args);
                if (result.then) {
                    result.then(function (data) { return resolve(data); }).catch(function (e) { return reject(e); });
                }
                else if (typeof result === 'string') {
                    finalRequestMethod(result).then(function (data) { resolve(data); }).catch(function (e) { return reject(e); });
                }
                else if (typeof result === 'object') {
                    // umi-request 需要拆分下字段
                    if (requestMethod) {
                        finalRequestMethod(result).then(function (data) { resolve(data); }).catch(function (e) { return reject(e); });
                    }
                    else {
                        var url = result.url, rest = __rest(result, ["url"]);
                        fetch(url, rest).then(function (data) { resolve(data); }).catch(function (e) { return reject(e); });
                    }
                }
            });
        };
    }
    if (loadMore) {
        return useLoadMore(promiseService, finalOptions);
    }
    if (paginated) {
        return usePaginated(promiseService, finalOptions);
    }
    return useAsync(promiseService, finalOptions);
}
var UseAPIProvider = ConfigContext.Provider;

var toString = Object.prototype.toString;
/**
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
    return toString.call(val) === '[object Array]';
}
/**
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') {
        return;
    }
    // Force an array if not already something iterable
    if (typeof obj !== 'object') {
        /*eslint no-param-reassign:0*/
        obj = [obj];
    }
    if (isArray(obj)) {
        // Iterate over array values
        for (var i = 0, l = obj.length; i < l; i++) {
            fn.call(null, obj[i], i, obj);
        }
    }
    else {
        // Iterate over object keys
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                fn.call(null, obj[key], key, obj);
            }
        }
    }
}
/**
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === 'object' && typeof val === 'object') {
            result[key] = merge(result[key], val);
        }
        else {
            result[key] = val;
        }
    }
    for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
    }
    return result;
}

var request = function (options) {
    return __awaiter(this, void 0, void 0, function () {
        var configInterceptors, endpoint, rest, interceptor, instance, _a, handleRequest, handleRequestError, _b, handleResponse, handleResponseError, reqURL, isAbsoluteURL, arr, response, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    configInterceptors = restConfig.interceptor, endpoint = restConfig.endpoint, rest = __rest(restConfig, ["interceptor", "endpoint"]);
                    interceptor = {};
                    if (configInterceptors)
                        interceptor = configInterceptors;
                    instance = axios.create(__assign({}, rest));
                    // 需要支持多个拦截器的情况
                    // 一个拦截器的情况：
                    // interceptor: {
                    //   responses: [handleResponse, handleResponseError], 第一个参数表示成功的处理函数，第二个参数表示失败的处理函数
                    // }
                    // 多个拦截器的情况：
                    // interceptor: {
                    //  responses: [
                    //    [handleResponse1, handleResponseError1],
                    //    [handleResponse2, handleResponseError2],
                    // ], 第一个参数表示成功的处理函数，第二个参数表示失败的处理函数
                    // }
                    // 请求拦截器
                    if (interceptor.requests && Array.isArray(interceptor.requests)) {
                        interceptor.requests.forEach(function (item) {
                            if (Array.isArray(item)) {
                                var req = item[0], reqErr = item[1];
                                if (typeof reqErr === 'function') {
                                    instance.interceptors.request.use(req, reqErr);
                                }
                                else {
                                    instance.interceptors.request.use(req);
                                }
                            }
                        });
                        _a = interceptor.requests, handleRequest = _a[0], handleRequestError = _a[1];
                        if (typeof handleRequest === 'function' && typeof handleRequestError === 'function') {
                            instance.interceptors.request.use(handleRequest, handleRequestError);
                        }
                        else if (typeof handleRequest === 'function' && handleRequestError === undefined) {
                            instance.interceptors.request.use(handleRequest);
                        }
                    }
                    // 响应拦截器
                    if (interceptor.responses && Array.isArray(interceptor.responses)) {
                        interceptor.responses.forEach(function (item) {
                            if (Array.isArray(item)) {
                                var res = item[0], resErr = item[1];
                                if (typeof resErr === 'function') {
                                    instance.interceptors.response.use(res, resErr);
                                }
                                else {
                                    instance.interceptors.response.use(res);
                                }
                            }
                        });
                        _b = interceptor.responses, handleResponse = _b[0], handleResponseError = _b[1];
                        if (typeof handleResponse === 'function' && typeof handleResponseError === 'function') {
                            instance.interceptors.response.use(handleResponse, handleResponseError);
                        }
                        else if (typeof handleResponse === 'function' && handleResponseError === undefined) {
                            instance.interceptors.response.use(handleResponse);
                        }
                    }
                    reqURL = options.url;
                    isAbsoluteURL = /http:\/\/|https:\/\//.test(options.url);
                    if (options.url.indexOf(dynamicLocaleDirPath) > -1) {
                        reqURL = options.url;
                    }
                    else if (isAbsoluteURL) {
                        reqURL = options.url;
                    }
                    else {
                        arr = options.url.split(/\s+/);
                        // handle something like: 'POST: /todos'
                        if (arr.length === 2) {
                            reqURL = arr[0] + " " + (endpoint + arr[1]);
                        }
                        else {
                            reqURL = endpoint + arr[0];
                        }
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, instance(__assign({}, options, { url: reqURL }))];
                case 2:
                    response = _c.sent();
                    if (response) {
                        return [2 /*return*/, Promise.resolve(response.data)];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
};
// Provide aliases for supported request methods
forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
    request[method] = function (url, config) {
        return request(merge(config || {}, {
            method: method,
            url: url,
        }));
    };
});
forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
    request[method] = function (url, data, config) {
        return request(merge(config || {}, {
            method: method,
            url: url,
            data: data,
        }));
    };
});

var _this = undefined;
function getOptions(options) {
    var defaultOpt = { method: 'POST' };
    if (!options)
        return defaultOpt;
    return __assign({}, defaultOpt, options);
}
var useUpdate = function (url, options) {
    var initialState = {};
    var _a = useState(initialState), result = _a[0], setState = _a[1];
    var updateData = function (updateOptions) { return __awaiter(_this, void 0, void 0, function () {
        var opt, data_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setState(function (prev) { return (__assign({}, prev, { loading: true })); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    opt = getOptions(options);
                    if (updateOptions)
                        opt = __assign({}, opt, updateOptions);
                    return [4 /*yield*/, fetch(url, opt)];
                case 2:
                    data_1 = _a.sent();
                    //  请求成功的回调函数
                    if (updateOptions && updateOptions.onSuccess) {
                        updateOptions.onSuccess(data_1);
                    }
                    setState(function (prev) { return (__assign({}, prev, { loading: false, data: data_1 })); });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    //  请求失败的回调函数
                    if (updateOptions && updateOptions.onError) {
                        updateOptions.onError(error_1);
                    }
                    setState(function (prev) { return (__assign({}, prev, { loading: false, error: error_1 })); });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var update = function (updateOptions) {
        updateData(updateOptions);
    };
    var out = [update, result];
    return out;
};

export { config, fetch, fetcher, request, restConfig, useRequest as useFetch, useUpdate };
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/rest/dist/index.es.js
// module id = 704
// module chunks = 0